export class UserSchoolYearPolicies {
    Id: number;
    Name: string;
    IsAllowTeacherToSetFinalGradeCalculation: boolean;
    FGradeCalculationType: number;
    SemesterFinalGradeCalculation: number;
    IsAllowTeacherToSelectAssignmentRoundingInGB: boolean;
    NumericalGradeRoundTo: number;
    IsAllowTeacherToSelectGPRoundingInGB: boolean;
    IsGPCWRoundDown: boolean;
    IsGPCWRoundUp: boolean;
    IsGPCWRoundTo: boolean;
    GPCWRoundToValue: number;
    IsAllowTeacherToSelectSemRoundingInGB: boolean;
    IsSemFinalRoundDown: boolean;
    IsSemFinalRoundUp: boolean;
    IsSemFinalRoundTo: boolean;
    SemFinalRoundToValue: number;
    DefaultParentPublish: boolean;
    AllowQuickAddAssignments: boolean;
    ShowMessageOnS360GradesPage: boolean;
    S360GradesMessage: string;
    ShowInactiveStudents: boolean;
    ScoreExceedPossible: boolean;
    DisableAutoSave: boolean;
    DisplayReportCardGrades: string;
    S360AcademicHistoryHideSemesterColumns: boolean;
    S360AcademicHistoryOnlyShowCompletedCourses: boolean;
    S360GradesDisplayFinalScoreGrade: boolean;
    S360DisplayCategoryScores: boolean;
    UpdateAttendanceforDisciplineSuspensions: boolean;
    TeacherRequestsIsActive: boolean;
    S360SchedulingCourseRequests: boolean;
    S360SchedulingClassScheduling: boolean;
    S360SchedulingStudentScheduling: boolean;
    SchoolId: number;
}
